import { useEffect } from "react";

const BRAND = "VittaSathi";

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title
      ? `${title} | ${BRAND}`
      : `${BRAND}: Plan, Track, and Grow Every Rupee`;
    return () => {
      document.title = `${BRAND}: Plan, Track, and Grow Every Rupee`;
    };
  }, [title]);
}
